import _ from 'lodash';
import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_NEW_STEP_CARD](state, p) {
    const drp = p.drp;
    drp.cards.push(p.newCard);
  },
  [types.REMOVE_STEP_CARD](state, p) {
    const drp = p.drp;
    drp.cards.splice(p.cardIndex, 1);
  },
  [types.SET_STEP_CARD_TEXT](state, p) {
    const drp = p.drp;
    drp.cards[p.cardIndex][p.type] = p[p.type];
  },
  [types.SET_STEP_CARD_HREF](state, p) {
    const drp = p.drp;
    const card = _.find(drp.cards, { _id: p.linkId });
    if (card && !_.isUndefined(p.link)) {
      card.href = p.link;
    }
  },
  [types.SET_STEP_CARD_WINDOW](state, p) {
    const drp = p.drp;
    const card = _.find(drp.cards, { _id: p.id });
    card.newWindow = p.newWindow;
    card.target = p.target;
  },
  [types.SET_STEP_CARD_ACTIVE_CARD](state, p) {
    const drp = p.drp;
    drp.activeCard = p.activeCard;
  },
};

const actions = {
  addNewStepCard: ({ commit }, payload) => {
    commit(types.ADD_NEW_STEP_CARD, payload);
  },
  removeStepCard: ({ commit }, payload) => {
    commit(types.REMOVE_STEP_CARD, payload);
  },
  async setStepCardText({ dispatch, commit }, payload) {
    payload[payload.type] = payload[payload.type];
    await commit(types.SET_STEP_CARD_TEXT, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
  setStepCardHref: ({ commit }, payload) => {
    commit(types.SET_STEP_CARD_HREF, payload);
  },
  setStepCardWindow: ({ commit }, payload) => {
    payload.target = (payload.newWindow) ? '_blank' : '_self';
    commit(types.SET_STEP_CARD_WINDOW, payload);
  },
  setStepCardActiveCard: ({ commit }, payload) => {
    commit(types.SET_STEP_CARD_ACTIVE_CARD, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-step/vuex.js